<template>
	<div class="service-tokens-page">
		<header class="header">
			<router-link to="/admin-panel" class="back-link"
				>← {{ t("adminPanelPage.serviceTokens.backToAdmin") }}</router-link
			>
			<div>
				<h1>{{ t("adminPanelPage.serviceTokens.pageTitle") }}</h1>
				<p>{{ t("adminPanelPage.serviceTokens.description") }}</p>
			</div>
		</header>
		<ServiceTokensPanel v-if="canManageServiceTokens" :api-token="store.userApiToken" />
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import ServiceTokensPanel from "@/components/admin/ServiceTokensPanel.vue"
import { Permission, UseRootStore } from "@/model/RootStore"

const router = useRouter()
const store = UseRootStore()
const { t } = useI18n()
const canManageServiceTokens = computed(() => store.currentUser?.has(Permission.ServiceTokenWrite) ?? false)

onMounted(() => {
	if (!canManageServiceTokens.value) router.push("/admin-panel")
})
</script>

<style scoped>
.service-tokens-page {
	width: min(95%, 1400px);
	margin: 0 auto;
	padding: var(--space-20);
}
.header {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	gap: var(--space-20);
	margin-bottom: var(--space-20);
}
.back-link {
	color: var(--accent-info);
	text-decoration: none;
	font-weight: var(--font-weight-medium);
}
.back-link:hover {
	text-decoration: underline;
}
h1,
p {
	margin: 0;
}
h1 {
	color: var(--neutral-900);
}
p {
	margin-top: var(--space-4);
	color: var(--neutral-600);
}
@media (max-width: 700px) {
	.header {
		align-items: flex-start;
		flex-direction: column-reverse;
	}
}
</style>
